export default "__VITE_ASSET__BafH_1yF__"